
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Sedancabservicemumbai() {



    const cardData =
    {
        keyword: ' Sedan Cab Service Mumbai',
        heading: 'Deva Cabs:  Sedan Cab Service Mumbai',
        headingDescription: 'Deva Cabs offers reliable, stylish, and hassle-free sedan cab services in Mumbai. Whether you need a comfortable ride for daily office travel, airport transfers, business meetings, or weekend getaways, our range of premium sedans—like Swift Dzire, Toyota Etios, and Honda Amaze—are perfect for smooth city and highway travel. Driven by courteous and experienced chauffeurs, our sedans provide a perfect blend of elegance, comfort, and affordability. With on-time pickups, flexible bookings, and competitive rates, Deva Cabs ensures a premium sedan cab experience across Mumbai every time.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

"topPlaces": [
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "location": "Mumbai, Maharashtra",
    "description": "A UNESCO World Heritage Site, CST (formerly Victoria Terminus) is a historic railway station in South Mumbai, built in 1887 in the Victorian Gothic Revival style. The station's stunning architecture, domes, turrets, pointed arches, and stained glass make it one of the most photographed buildings in India. Still functioning as a busy train terminal, CST represents the fusion of British and Indian architectural traditions and serves as a central landmark in Mumbai's bustling Fort area."
  },
    {
    "title": "Gateway of India",
    "location": "Mumbai, Maharashtra",
    "description": "The Gateway of India is Mumbai’s most iconic monument, built in 1924 to commemorate the visit of King George V and Queen Mary. Located by the Arabian Sea in Colaba, this Indo-Saracenic structure stands 26 meters tall and draws millions of tourists each year. It serves as a starting point for ferry rides to Elephanta Caves and offers scenic views, especially during sunrise and sunset. Surrounded by bustling vendors, photographers, and the majestic Taj Mahal Palace Hotel, it’s a must-visit symbol of the city’s colonial past and vibrant present."
  },
  {
    "title": "Marine Drive",
    "location": "Mumbai, Maharashtra",
    "description": "Marine Drive, also known as the 'Queen’s Necklace', is a 3.6 km long C-shaped boulevard along the Arabian Sea in South Mumbai. Lined with palm trees and iconic Art Deco buildings (a UNESCO heritage stretch), it offers an idyllic promenade for evening walks and ocean breezes. At night, the streetlights create a necklace-like illusion across the bay. Locals and tourists come here to relax, jog, enjoy local snacks at Chowpatty Beach, or simply take in the magnificent sunset skyline."
  },
  {
    "title": "Elephanta Caves",
    "location": "Elephanta Island, Mumbai, Maharashtra",
    "description": "Situated on Elephanta Island, about 11 km from the Gateway of India, the Elephanta Caves are a UNESCO World Heritage Site featuring ancient rock-cut cave temples dedicated to Lord Shiva. The main cave houses the iconic 20-foot Trimurti sculpture, representing Shiva in three forms. Dating back to the 5th to 7th centuries, these caves offer a unique glimpse into India's early rock architecture. Visitors reach the island via ferry and can enjoy scenic views, local souvenirs, and a toy train ride upon arrival."
  },
  {
    "title": "Juhu Beach",
    "location": "Mumbai, Maharashtra",
    "description": "Juhu Beach is one of the most famous and accessible beaches in Mumbai, stretching along the Arabian Sea in the upscale Juhu suburb. It's a popular spot for watching sunsets, street food (try bhelpuri and pav bhaji), and celebrity sightings. On weekends and during festivals like Ganesh Chaturthi, the beach becomes a vibrant social hub with locals, tourists, kids, and vendors creating a lively atmosphere. Its proximity to film studios and luxury hotels also makes it a favorite among Bollywood stars."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "location": "Borivali, Mumbai, Maharashtra",
    "description": "Sanjay Gandhi National Park is a 100-square-kilometer green oasis within Mumbai, offering a mix of nature, history, and adventure. Home to leopards, deer, and over 250 species of birds, the park also houses the 2,000-year-old Kanheri Caves, which are Buddhist rock-cut monuments carved into basalt rock. Visitors can enjoy jungle safaris, cycling trails, boating, toy train rides, and trekking paths—making it an ideal retreat for families and nature lovers right within city limits."
  },
  {
    "title": "Haji Ali Dargah",
    "location": "Mumbai, Maharashtra",
    "description": "Haji Ali Dargah is a revered Islamic shrine located on an islet off the coast of Worli in South Mumbai. Built in 1431, it houses the tomb of the saint Pir Haji Ali Shah Bukhari. The white marble structure is accessible via a narrow walkway surrounded by water, especially mesmerizing during high tide. It's a spiritual destination visited by people of all faiths, offering stunning views of the sea and the city’s skyline."
  },
  {
    "title": "Chor Bazaar",
    "location": "Mumbai, Maharashtra",
    "description": "Chor Bazaar, meaning 'Thieves' Market', is one of the oldest and most fascinating flea markets in Mumbai. Located near Grant Road, it’s a treasure trove for antique collectors and bargain hunters. You'll find vintage Bollywood posters, colonial furniture, old gramophones, brassware, and more. Though it was once associated with stolen goods, today it’s more about quirky curios and Mumbai’s vintage charm."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "location": "Mumbai, Maharashtra",
    "description": "Officially named Rajiv Gandhi Sea Link, this 5.6 km long cable-stayed bridge connects the suburbs of Bandra to Worli, reducing travel time dramatically. The bridge stands as a symbol of modern Mumbai, offering scenic views of the city’s skyline and the Arabian Sea. It’s especially stunning at night when illuminated. While stopping is prohibited on the bridge, the view from Bandra Fort or Worli Sea Face is a favorite for photographers and couples."
  },
  {
    "title": "Global Vipassana Pagoda",
    "location": "Gorai, Mumbai, Maharashtra",
    "description": "The Global Vipassana Pagoda is a massive meditation hall built as a tribute to the teachings of Lord Buddha. Its dome, one of the world’s largest stone structures without supporting pillars, can seat over 8,000 people. Located near Gorai Creek, the pagoda complex includes a museum, library, and guided Anapana meditation sessions. Its golden structure and peaceful surroundings attract spiritual seekers and curious tourists alike."
  }
],



  "services": [
    {
      "name": "Sedan Cab Service Mumbai",
      "description": "Deva Cabs offers reliable and comfortable sedan cab services in Mumbai for all kinds of travel needs. Whether you're heading to a business meeting, a family function, or need a smooth ride to your destination, our sedans provide the perfect blend of elegance and affordability. Our fleet includes top sedan models that are spacious, air-conditioned, and maintained to high standards. With professional, courteous chauffeurs and transparent pricing, we ensure a stress-free ride every time. Our sedan cab service is available 24/7 for local, airport, and outstation travel."
    },
    {
      "name": "Book Sedan Cab Mumbai",
      "description": "Booking a sedan cab in Mumbai has never been easier with Deva Cabs. Our streamlined online booking system lets you reserve a car quickly with instant confirmation. Just select your pickup point, destination, and schedule — and our team will handle the rest. Our sedans are ideal for solo travelers, couples, and professionals looking for a hassle-free, comfortable travel experience within or outside Mumbai. Get door-to-door service with complete punctuality and clean, well-maintained vehicles."
    },
    {
      "name": "Chauffeur Sedan Taxi Mumbai",
      "description": "Enjoy a premium travel experience with Deva Cabs’ chauffeur-driven sedan taxi service in Mumbai. All our chauffeurs are trained, background-verified, and committed to offering courteous service and safe driving. Whether it’s a formal business trip or a special occasion, riding in a chauffeur-driven sedan elevates your travel comfort. The cars are fitted with AC, spacious legroom, and quiet interiors — making them ideal for those who want a relaxing commute around Mumbai."
    },
    {
      "name": "Affordable Sedan Cab Hire Mumbai",
      "description": "Looking for a budget-friendly travel solution without compromising on comfort? Deva Cabs’ affordable sedan cab hire in Mumbai is the perfect choice. Whether it’s for a few hours or a full day, our pricing plans are designed to offer maximum value. Enjoy premium quality vehicles and trained drivers at rates that suit your budget. Great for office commutes, city tours, errands, or daily transport, our sedans provide a cost-effective yet classy way to travel around Mumbai."
    },
    {
      "name": "AC Sedan Taxi Mumbai",
      "description": "Beat the Mumbai heat and travel in comfort with our fully air-conditioned sedan taxis. Every sedan in our fleet comes equipped with powerful AC, plush seating, and ample luggage space, making your ride relaxing even during peak summers. Our drivers ensure smooth navigation through traffic, while you sit back and enjoy the journey. Choose AC sedans for both local and long-distance travel at affordable rates with full comfort assurance."
    },
    {
      "name": "Luxury Sedan Cab Rental Mumbai",
      "description": "For those seeking a touch of sophistication, our luxury sedan cab rentals in Mumbai offer the ideal upgrade. We provide access to premium sedan models, perfect for executive travel, VIP guest transfers, or special events. Expect high-end interiors, superior ride quality, and professional chauffeurs trained for luxury service. Available for hourly, daily, and custom packages, our luxury sedan rentals bring class and comfort together effortlessly."
    },
    {
      "name": "Sedan for Airport Cab Mumbai",
      "description": "Travel to or from Mumbai Airport in comfort and style with our sedan cab airport transfer service. We offer timely pickups and drop-offs with real-time flight tracking to ensure you’re never late. Our drivers are familiar with all airport routes and parking points, minimizing your stress during travel. Whether arriving or departing, our AC sedan taxis provide the perfect blend of speed, safety, and convenience for airport transportation."
    },
    {
      "name": "Outstation Sedan Cab Mumbai",
      "description": "Planning an outstation trip from Mumbai? Deva Cabs offers reliable sedan cab services for long-distance journeys to Pune, Lonavala, Nashik, Goa, and more. Our sedans are equipped for highway travel, with spacious seating, powerful AC, and experienced drivers who know the best routes. With flexible pricing options and 24/7 customer support, your outstation travel experience will be smooth, safe, and enjoyable. Ideal for individuals, couples, or small families."
    },
    {
      "name": "Corporate Sedan Car Hire Mumbai",
      "description": "Deva Cabs caters to businesses and executives with professional corporate sedan car hire in Mumbai. Whether it’s for regular staff transport, client meetings, or corporate events, our sedan service offers reliability, punctuality, and executive-class comfort. We provide monthly billing, GST invoicing, and corporate packages for frequent users. Our drivers are trained in business etiquette and ensure a top-tier travel experience for all corporate clients."
    },
    {
      "name": "Family Sedan Cab Mumbai",
      "description": "Traveling with your family? Our sedan cabs in Mumbai are a perfect choice for family outings, airport drops, or weekend getaways. Spacious enough for small families, our sedans ensure comfort, safety, and a smooth ride for all passengers. Child-friendly, AC-equipped, and driven by courteous professionals, our sedan cabs make every family journey convenient and enjoyable. Book in advance or get instant availability online or via call."
    },
    {
      "name": "Premium Sedan Car Rental Mumbai",
      "description": "Step into a world of elegance with our premium sedan rentals in Mumbai. Tailored for special occasions, business trips, or those who simply want a touch of luxury, our premium sedans feature high-end interiors, polished exteriors, and top-grade comfort. With uniformed chauffeurs, on-time service, and full-day rental options, premium sedan rentals from Deva Cabs redefine class and convenience for your travel needs."
    },
    {
      "name": "Sedan Cab for Events Mumbai",
      "description": "Attending or hosting an event in Mumbai? Our sedan cabs are the perfect transport solution for weddings, conferences, exhibitions, or private functions. We offer dedicated event-day cab coordination, punctual pickups, and well-groomed drivers. Choose from a fleet of stylish sedans to arrive in elegance and comfort. Book one or multiple cabs depending on your event size and transport requirements."
    },
    {
      "name": "Sedan Tour Cab Mumbai",
      "description": "Explore Mumbai’s iconic sights in a relaxing sedan tour cab. From Marine Drive to Gateway of India, Juhu Beach to Siddhivinayak Temple — our city tour packages let you discover Mumbai’s charm from the comfort of a premium sedan. Our drivers are knowledgeable about the city’s history and can guide you through flexible routes and attractions. Book half-day or full-day packages at great rates."
    }
  ],
  "tableData": [
    ["Sedan Cab Service Mumbai", "-Book Sedan Cab Mumbai"],
    ["Chauffeur Sedan Taxi Mumbai", "-Affordable Sedan Cab Hire Mumbai"],
    ["AC Sedan Taxi Mumbai", "-Luxury Sedan Cab Rental Mumbai"],
    ["Sedan for Airport Cab Mumbai", "-Outstation Sedan Cab Mumbai"],
    ["Corporate Sedan Car Hire Mumbai", "-Family Sedan Cab Mumbai"],
    ["Premium Sedan Car Rental Mumbai", "-Sedan Cab for Events Mumbai"],
    ["Sedan Tour Cab Mumbai", ""]
  ],

whychoose: [
  {
    "WhyChooseheading": "Comfortable and Spacious Sedan Fleet",
    "WhyChoosedescription": "Deva Cabs offers a premium range of sedan cabs in Mumbai, including models like Swift Dzire, Toyota Etios, and Honda Amaze. Our sedans are perfect for travelers who prioritize legroom, smooth rides, and air-conditioned comfort—ideal for business trips, airport transfers, or city rides with family."
  },
  {
    "WhyChooseheading": "Trained Chauffeurs for a Professional Experience",
    "WhyChoosedescription": "All our sedan cabs are driven by experienced, background-verified drivers who understand Mumbai’s traffic and routes thoroughly. Courteous and punctual, they ensure you arrive at your destination safely, comfortably, and on time—every time."
  },
  {
    "WhyChooseheading": "Perfect for Business and Leisure Travel",
    "WhyChoosedescription": "Whether you’re heading to a client meeting in BKC, sightseeing in South Mumbai, or catching a flight from the airport, our sedan cabs are the ideal blend of style and practicality. Enjoy a refined travel experience for both personal and professional needs."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Our sedan cab services in Mumbai are competitively priced with no hidden charges. We offer full pricing transparency—what you see is what you pay. Choose from hourly rentals, one-way rides, or full-day bookings to suit your travel plans and budget."
  },
  {
    "WhyChooseheading": "Available 24/7 Across Mumbai",
    "WhyChoosedescription": "Deva Cabs operates around the clock, offering sedan taxi services day and night across all areas of Mumbai—from Colaba to Borivali, Andheri to Navi Mumbai. No matter when or where you need a cab, we’re always ready to serve you."
  },
  {
    "WhyChooseheading": "Real-Time Booking and Live Tracking",
    "WhyChoosedescription": "Booking a sedan cab with Deva Cabs is fast and seamless. Use our app or website to schedule your ride instantly and track your driver in real-time. Prefer a human touch? Our 24/7 helpline is ready to help with bookings or special requests."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicles with Clean Interiors",
    "WhyChoosedescription": "All our sedan cabs are regularly serviced, cleaned, and sanitized to ensure maximum hygiene and comfort. Expect well-kept seats, working AC, and a pleasant in-cab environment—every time you ride with Deva Cabs."
  },
  {
    "WhyChooseheading": "Custom Packages for Corporate and Personal Use",
    "WhyChoosedescription": "Need a sedan for a few hours, a full day, or recurring travel? We offer flexible rental options for individuals and businesses alike. Choose from one-time rides, return trips, or corporate travel plans with billing, priority pickups, and more."
  }
]













    }




const faqData = [
  {
    question: "Does Deva Cabs offer sedan cab service in Mumbai?",
    answer: "Yes, Deva Cabs provides comfortable and affordable sedan cab services across Mumbai. You can book a sedan through our website, mobile app, or by contacting our customer support."
  },
  {
    question: "What types of sedan cars are available with Deva Cabs in Mumbai?",
    answer: "We offer a range of sedan options including Swift Dzire, Toyota Etios, Honda Amaze, and Hyundai Aura to suit your comfort and travel needs."
  },
  {
    question: "Is the sedan cab service available for airport transfers in Mumbai?",
    answer: "Yes, our sedan cabs are available for pick-up and drop-off services at Mumbai International and Domestic Airports."
  },
  {
    question: "Can I book a sedan cab for outstation trips from Mumbai?",
    answer: "Absolutely! Our sedan cabs are available for both local and outstation trips from Mumbai to popular destinations like Pune, Lonavala, Nashik, and more."
  },
  {
    question: "What are the charges for booking a sedan cab in Mumbai?",
    answer: "The charges depend on the duration, distance, and type of service (local or outstation). You can get an instant fare quote via our website or mobile app."
  },
  {
    question: "Can I pre-schedule a sedan cab in Mumbai?",
    answer: "Yes, you can pre-schedule your sedan cab in advance through our app or website to ensure timely pick-up and convenience."
  },
  {
    question: "Are the sedan cabs well-maintained and clean?",
    answer: "Yes, all our sedan cabs are regularly serviced, clean, and inspected to ensure a smooth and pleasant ride."
  },
  {
    question: "Are the drivers professional and experienced?",
    answer: "Yes, all our drivers are verified, experienced, and trained to deliver safe and courteous service throughout Mumbai."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Deepak Nair',
    role: 'Corporate Client',
    review: 'I frequently use Deva Cabs’ sedan service for meetings across Mumbai. The cars are always clean, and the drivers are very professional. Highly recommended for business travelers.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Kavita Shetty',
    role: 'Frequent Commuter',
    review: 'I’ve booked sedan cabs multiple times with Deva Cabs for airport and city travel. The rides are always punctual and comfortable. A very dependable service!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];

































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Sedan Cab Service Mumbai",
  "image": "https://devacab.com/assets/images/sedan-cab-service-mumbai.jpg", // Replace with actual image URL
  "description": "Book sedan cab service in Mumbai with Deva Cabs. Comfortable and affordable AC sedans for airport transfers, city tours, outstation trips, corporate travel, events, and family rides. Chauffeur-driven with luxury and economy options.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1199", // Example price, update if needed
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/sedan-cab-service-mumbai" // Replace with actual page URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Sedan Cab Service Mumbai | Book Chauffeur-Driven Sedan | Deva Cabs</title>
  <meta
    name="description"
    content="Book sedan cab service in Mumbai with Deva Cabs. Chauffeur-driven AC sedans available for airport transfers, outstation trips, events, corporate travel, and city tours. Affordable and premium car hire options."
  />
  <meta
    name="keywords"
    content="Sedan Cab Service Mumbai, Book sedan cab Mumbai, Chauffeur sedan taxi Mumbai, Affordable sedan cab hire Mumbai, AC sedan taxi Mumbai, Luxury sedan cab rental Mumbai, Sedan for airport cab Mumbai, Outstation sedan cab Mumbai, Corporate sedan car hire Mumbai, Family sedan cab Mumbai, Premium sedan car rental Mumbai, Sedan cab for events Mumbai, Sedan tour cab Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/70.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Sedancabservicemumbai;